module.exports = {"id":"204639","name":"Stefan Savić","rating":"82","photo":"./data/images/photos/1/204639.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StefanSavic0.json
// module id = 4014
// module chunks = 0